var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { alignItems, display, flex, justifyContent, maxWidth, space, } from 'styled-system';
import cookieStorage from '../../common/CookieStorage';
import { FlexAlignItems, FlexJustifyContent, FlexWrap, FullWidthBoxShadow, Grid, GridItem, } from '../../common/components/Grid';
import { CartSubscription, SideNavSubscription, WishlistSubscription, } from '../../common/event-bus/EventSubscription';
import MenuButton from './MenuButton/MenuButton';
import Logo, { ImageFormat } from './Logo/Logo';
import Search from './Search/Search';
import ActionItem from './ActionIcons/ActionItem';
import AsyncTooltip from './ActionIcons/MyAccountTooltip/AsyncTooltip';
import LanguageSwitch from './LanguageSwitch';
var ToolbarGrid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
ToolbarGrid.defaultProps = {
    as: Grid,
    alignItems: FlexAlignItems.CENTER,
    justifyContent: FlexJustifyContent.SPACE_BETWEEN,
    flexWrap: [FlexWrap.WRAP, FlexWrap.NO_WRAP],
    py: [3, null, '12px'],
};
var LeftSectionGridItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), flex, display, alignItems);
LeftSectionGridItem.defaultProps = {
    as: GridItem,
    w: 'auto',
    alignItems: 'center',
    display: 'flex',
    order: 1,
    flex: 'none',
};
var CenterSectionGridItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), flex, maxWidth);
CenterSectionGridItem.defaultProps = {
    as: GridItem,
    w: [1, 'auto'],
    order: [3, 2],
    maxWidth: [null, '420px', null, '512px'],
    // We are so specific with numbers because of IE
    flex: ['1 0 100%', '1 1 420px', null, '1 1 512px'],
};
var RightSectionGridItem = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), flex, display, justifyContent);
RightSectionGridItem.defaultProps = {
    as: GridItem,
    w: 'auto',
    ml: ['auto', 0],
    display: 'flex',
    order: [2, 3],
    justifyContent: 'flex-end',
    flex: 'none',
};
var RightSectionItem = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  ", ";\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), space);
RightSectionItem.defaultProps = {
    ml: [0, 2, 3, '24px'],
};
var ToolbarActionItem = function (_a) {
    var Subscription = _a.Subscription, Tooltip = _a.Tooltip, item = __rest(_a, ["Subscription", "Tooltip"]);
    return (React.createElement(RightSectionItem, null,
        React.createElement(Subscription, null, function (_a) {
            var value = _a.value;
            return (React.createElement(ActionItem, { id: item.id, icon: item.icon, label: item.label, url: item.url, count: value, countThreshold: item.countThreshold }, function (_a) {
                var shouldShowChildren = _a.shouldShowChildren, isActionItemActive = _a.isActionItemActive;
                if (Tooltip && shouldShowChildren) {
                    return isActionItemActive && React.createElement(Tooltip, null);
                }
                return null;
            }));
        })));
};
var ToolbarActionItemPropTypes = {
    id: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    Tooltip: PropTypes.object,
    Subscription: PropTypes.func,
};
ToolbarActionItem.propTypes = ToolbarActionItemPropTypes;
ToolbarActionItem.defaultProps = {
    Subscription: function (_a) {
        var children = _a.children;
        return children({});
    },
};
var actionItems = [
    {
        // INFO: We are using the same ids to trick React into
        // thinking that those items are the same
        id: 'userAccount',
        icon: 'Account',
        label: 'h24_register',
        url: 'h24_register_url',
        Tooltip: AsyncTooltip,
        auth: false,
    },
    {
        id: 'userAccount',
        icon: 'Account',
        label: 'h24_my_account',
        url: 'h24_my_overview_url',
        Tooltip: AsyncTooltip,
        auth: true,
    },
    {
        id: 'wishlist',
        icon: 'Wishlist',
        label: 'h24_wishlist',
        url: 'h24_wishlist_url',
        Subscription: WishlistSubscription,
    },
    {
        id: 'cart',
        icon: 'Cart',
        label: 'h24_cart',
        url: 'h24_cart_url',
        Subscription: CartSubscription,
        countThreshold: 0,
    },
];
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { customer: null };
        return _this;
    }
    Toolbar.prototype.componentDidMount = function () {
        this.setState({
            customer: cookieStorage.getCustomer(),
        });
    };
    Toolbar.prototype.render = function () {
        var customer = this.state.customer;
        var __legacy_shop_reboot_max_width = this.props.__legacy_shop_reboot_max_width;
        var isLoggedIn = !!(customer && customer.isLoggedIn);
        return (React.createElement(ToolbarGrid, { "data-testid": "toolbar", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, fullWidthBoxShadow: FullWidthBoxShadow.BOTTOM },
            React.createElement(LeftSectionGridItem, null,
                React.createElement(SideNavSubscription, null, function (_a) {
                    var emit = _a.emit;
                    return React.createElement(MenuButton, { onClick: function () { return emit(true); } });
                }),
                React.createElement(Logo, { imageFormat: ImageFormat.GIF })),
            React.createElement(CenterSectionGridItem, { maxWidth: 
                // Big size looks weird when we are still "locked"
                // in Reboot land
                __legacy_shop_reboot_max_width
                    ? [null, '420px']
                    : [null, '420px', null, '512px'] },
                React.createElement(Search, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width })),
            React.createElement(RightSectionGridItem, null,
                actionItems
                    .filter(function (_a) {
                    var auth = _a.auth;
                    return typeof auth === 'undefined' || auth === isLoggedIn;
                })
                    .map(function (item) { return (React.createElement(ToolbarActionItem, __assign({ key: item.id }, item))); }),
                React.createElement(LanguageSwitch, null))));
    };
    Toolbar.propTypes = {
        /** List of toolbar action items displayed next to the search bar. */
        actionItems: PropTypes.arrayOf(PropTypes.shape(ToolbarActionItemPropTypes)),
        /** Should the max width be capped by current Reboot max width (default: true) */
        __legacy_shop_reboot_max_width: PropTypes.bool,
    };
    Toolbar.defaultProps = {
        actionItems: actionItems,
        __legacy_shop_reboot_max_width: true,
    };
    return Toolbar;
}(React.Component));
export default Toolbar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
